var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.timezone != _vm.$laravel.user.timezone)?_c('b-message',{attrs:{"type":"is-warning","has-icon":""}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('timezone_warning_description', {timezone: _vm.timezoneText}))}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }